// i18n bootstrap — initializes react-i18next with the Phase 1 message
// dictionary. Language is driven by AudioContext's `language` state so
// changing the language picker in the Header automatically retranslates
// every component using `useTranslation()`. We DON'T enable browser
// language detection because that would override the explicit selector.
//
// Falls back to English for any missing key — so adding a new string
// without translating it doesn't blow up production, it just shows the
// English source. Phase 2 will fill the gaps.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import messages from "./i18nMessages";

const resources = Object.fromEntries(
  Object.entries(messages).map(([lng, dict]) => [lng, { translation: dict }])
);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false }, // React handles XSS
    react: { useSuspense: false },
  });

export default i18n;
